import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignInAlt,
  faEnvelope,
  faLock,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { authenticateUser } from "../../services/index";

const Login = (props) => {
  const [error, setError] = useState();
  const [show, setShow] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const initialState = {
    email: "",
    password: "",
  };

  const [user, setUser] = useState(initialState);

  const credentialChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const dispatch = useDispatch();

  const validateUser = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      await dispatch(authenticateUser(user.email, user.password));
      props.history.push("/trade_app/home");
    } catch (error) {
        console.log(error.message);
        setShow(true);
      setError(error.response?.data?.error || "Invalid email or password");
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && user.email && user.password) {
      validateUser(e);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Logo Section */}
        <div className="login-header">
          <div className="login-logo">
            <span className="logo-icon">📈</span>
            <span className="logo-text">TradeJet</span>
          </div>
          <p className="login-subtitle">Sign in to your account</p>
        </div>

        {/* Alerts */}
        {show && props.message && (
          <Alert variant="success" onClose={() => setShow(false)} dismissible>
            {props.message}
          </Alert>
        )}
        {show && error && (
          <Alert variant="danger" onClose={() => setShow(false)} dismissible>
            {error}
          </Alert>
        )}

        {/* Login Form */}
        <form onSubmit={validateUser}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div className="input-wrapper">
              <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
              <input
                type="email"
                    name="email"
                    value={user.email}
                    onChange={credentialChange}
                onKeyPress={handleKeyPress}
                className="form-input"
                placeholder="Enter your email"
                required
                autoComplete="email"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-wrapper">
              <FontAwesomeIcon icon={faLock} className="input-icon" />
              <input
                    type="password"
                    name="password"
                    value={user.password}
                    onChange={credentialChange}
                onKeyPress={handleKeyPress}
                className="form-input"
                placeholder="Enter your password"
                required
                autoComplete="current-password"
              />
            </div>
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={isLoading || !user.email || !user.password}
          >
            {isLoading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="btn-icon" />
                Signing in...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faSignInAlt} className="btn-icon" />
                Sign In
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="login-footer">
          <p>Don't have an account? Contact your administrator.</p>
        </div>
      </div>

      {/* Background Elements */}
      <div className="login-bg-element login-bg-1"></div>
      <div className="login-bg-element login-bg-2"></div>

      <style>{`
        .login-container {
          min-height: calc(100vh - 100px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          position: relative;
          overflow: hidden;
        }

        .login-card {
          width: 100%;
          max-width: 420px;
          background: linear-gradient(145deg, #1e293b 0%, #0f172a 100%);
          border: 1px solid rgba(51, 65, 85, 0.5);
          border-radius: 24px;
          padding: 48px 40px;
          box-shadow: 0 25px 80px -12px rgba(0, 0, 0, 0.6),
                      0 0 40px rgba(6, 182, 212, 0.1);
          position: relative;
          z-index: 1;
          animation: slideUp 0.5s ease-out;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .login-header {
          text-align: center;
          margin-bottom: 36px;
        }

        .login-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .logo-icon {
          font-size: 40px;
        }

        .logo-text {
          font-size: 32px;
          font-weight: 700;
          background: linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .login-subtitle {
          color: #64748b;
          font-size: 15px;
          margin: 0;
        }

        .form-group {
          margin-bottom: 24px;
        }

        .form-label {
          display: block;
          color: #94a3b8;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 8px;
        }

        .input-wrapper {
          position: relative;
        }

        .input-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: #64748b;
          font-size: 16px;
          transition: color 0.2s ease;
        }

        .form-input {
          width: 100%;
          background: #0f172a;
          border: 1px solid #334155;
          border-radius: 12px;
          padding: 14px 16px 14px 48px;
          color: #f1f5f9;
          font-size: 15px;
          transition: all 0.2s ease;
          outline: none;
        }

        .form-input:focus {
          border-color: #06b6d4;
          box-shadow: 0 0 0 4px rgba(6, 182, 212, 0.15);
        }

        .form-input:focus + .input-icon,
        .input-wrapper:focus-within .input-icon {
          color: #06b6d4;
        }

        .form-input::placeholder {
          color: #475569;
        }

        .login-button {
          width: 100%;
          background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
          border: none;
          border-radius: 12px;
          padding: 16px;
          color: white;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
          margin-top: 8px;
        }

        .login-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px -5px rgba(6, 182, 212, 0.5);
        }

        .login-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .btn-icon {
          font-size: 16px;
        }

        .login-footer {
          text-align: center;
          margin-top: 32px;
          padding-top: 24px;
          border-top: 1px solid #334155;
        }

        .login-footer p {
          color: #64748b;
          font-size: 14px;
          margin: 0;
        }

        /* Background Elements */
        .login-bg-element {
          position: fixed;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.4;
          pointer-events: none;
        }

        .login-bg-1 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, #06b6d4 0%, transparent 70%);
          top: -100px;
          right: -100px;
        }

        .login-bg-2 {
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, #3b82f6 0%, transparent 70%);
          bottom: -150px;
          left: -150px;
        }

        /* Alert Overrides */
        .login-card .alert {
          margin-bottom: 24px;
          border-radius: 12px;
          font-size: 14px;
        }

        @media (max-width: 480px) {
          .login-card {
            padding: 32px 24px;
            border-radius: 20px;
          }
          
          .logo-text {
            font-size: 28px;
          }
          
          .logo-icon {
            font-size: 32px;
          }
        }
      `}</style>
    </div>
  );
};

export default Login;
